export default __webpack_public_path__ + "static/media/yikes.a02ad44a.gif";